const MultiMedia = ({ color = "currentColor" }) => (
  <svg width="1em" height="1em" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12.7084 7.29167V3.95833C12.7084 3.03786 11.9622 2.29167 11.0417 2.29167H3.95841C3.03794 2.29167 2.29175 3.03786 2.29175 3.95833V11.0417C2.29175 11.9621 3.03794 12.7083 3.95841 12.7083H7.29175M2.58341 9.91667L4.07871 8.93699C4.63746 8.57091 5.36079 8.57381 5.91659 8.94434L6.98246 9.65492M5.00008 5.20833H5.41675M12.0834 12.5002H12.5001M5.62508 5.20833C5.62508 5.43845 5.43853 5.625 5.20841 5.625C4.9783 5.625 4.79175 5.43845 4.79175 5.20833C4.79175 4.97821 4.9783 4.79167 5.20841 4.79167C5.43853 4.79167 5.62508 4.97821 5.62508 5.20833ZM11.4584 11V14L13.7917 12.5L11.4584 11ZM16.0417 17.7083H8.95842C8.03794 17.7083 7.29175 16.9621 7.29175 16.0417V8.95833C7.29175 8.03786 8.03794 7.29167 8.95842 7.29167H16.0417C16.9622 7.29167 17.7084 8.03786 17.7084 8.95833V16.0417C17.7084 16.9621 16.9622 17.7083 16.0417 17.7083Z"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export default MultiMedia
